import OrganizeRequestedFilesSelect from './OrganizeRequestedFilesSelect.component';

export default OrganizeRequestedFilesSelect;